var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPGeneralPlantRoom = function SvgPGeneralPlantRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 684.2 480.2",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 684.2 480.2"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M592.1,454.1h-500v-308h500V454.1z M575.1,162.1h-466v276h466V162.1z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.1,452.1h-496v-304h496V452.1z M577.1,160.1h-470v280h470V160.1z",
    fill: "#C3C3C3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 321.6,
    y: 4.6,
    width: 41,
    height: 41,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.1,5.1v40h-40v-40L362.1,5.1 M363.1,4.1h-42v42h42V4.1L363.1,4.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M342.1,10.5l15.2,12.9h-3.6v18.4h-23.2V23.4h-3.6L342.1,10.5 M342.1,8.8l-18.7,15.9h5.8v18.4H355V24.7h5.8L342.1,8.8 L342.1,8.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M355.7,17h-1.5v-0.8c0-1-0.3-1.8-0.9-2.2c-0.9-0.7-2.4-0.5-2.4-0.5l-0.7,0.1v-1.5l0.4-0.1c0.1,0,2.1-0.4,3.6,0.8 c0.9,0.7,1.4,1.8,1.4,3.3L355.7,17L355.7,17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.3,16.3v0.8h-1.5v-0.8c0-1.8-0.5-3.1-1.5-4c-1.7-1.5-4.3-1.1-4.4-1.1l-0.7,0.1V9.8l0.5-0.1c0.1,0,3.3-0.4,5.6,1.5 C357.6,12.4,358.3,14.1,358.3,16.3L358.3,16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.8,16.3v0.8h-1.5v-0.8c0-2.6-0.7-4.6-2.2-5.8c-2.4-2.1-6.1-1.7-6.2-1.7l-0.7,0.1V7.3l0.5-0.1c0.2,0,4.4-0.5,7.4,2.1 C359.9,10.9,360.8,13.3,360.8,16.3L360.8,16.3L360.8,16.3z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "326,7.2 323.5,14.6 325.2,14.6 323.4,21.5 329.2,11.6 326.6,11.6 328.7,7.2"
  }))));
};
export default SvgPGeneralPlantRoom;